import RestService from './RestService';

export default class AwarePhishService extends RestService {
    constructor(companiesService, companyId) {
        if (!companiesService || !companyId) {
            throw new Error('Companies service and companyId are required');
        }
        super(`${companiesService.baseUrl}/${companyId}/aware-phish`);
        this.companyId = companyId;
    }

    config() {
        return this.get(`${this.baseUrl}/config`);
    }

    summary() {
        return this.get(`${this.baseUrl}/summary`);
    }

    listCampaigns() {
        return this.get(`${this.baseUrl}/campaigns`);
    }

    getCampaign(campaignId) {
        return this.get(`${this.baseUrl}/campaigns/${campaignId}`);
    }

    createCampaign(payload) {
        return this.post(`${this.baseUrl}/campaigns`, payload);
    }

    listTemplates() {
        return this.get(`${this.baseUrl}/templates`);
    }

    createTemplate(payload) {
        return this.post(`${this.baseUrl}/templates`, payload);
    }

    generateTemplate(payload) {
        return this.post(`${this.baseUrl}/templates/generate`, payload);
    }

    updateTemplate(templateId, payload) {
        return this.put(`${this.baseUrl}/templates/${templateId}`, payload);
    }

    deleteTemplate(templateId) {
        return this.del(`${this.baseUrl}/templates/${templateId}`);
    }

    listSendingProfiles() {
        return this.get(`${this.baseUrl}/sending-profiles`);
    }

    createSendingProfile(payload) {
        return this.post(`${this.baseUrl}/sending-profiles`, payload);
    }

    updateSendingProfile(profileId, payload) {
        return this.put(
            `${this.baseUrl}/sending-profiles/${profileId}`,
            payload
        );
    }

    deleteSendingProfile(profileId) {
        return this.del(`${this.baseUrl}/sending-profiles/${profileId}`);
    }

    getDelivery() {
        return this.get(`${this.baseUrl}/delivery`);
    }

    updateDelivery(payload) {
        return this.put(`${this.baseUrl}/delivery`, payload);
    }

    sendDeliveryTest(payload) {
        return this.post(`${this.baseUrl}/delivery/test-send`, payload);
    }

    saveReporting(payload) {
        return this.put(`${this.baseUrl}/delivery/reporting`, payload);
    }

    testReporting() {
        return this.post(`${this.baseUrl}/delivery/reporting/test`, {});
    }

    listDeliveryProfiles() {
        return this.get(`${this.baseUrl}/delivery-profiles`);
    }

    getDeliveryProfile(profileId) {
        return this.get(`${this.baseUrl}/delivery-profiles/${profileId}`);
    }

    createDeliveryProfile(payload) {
        return this.post(`${this.baseUrl}/delivery-profiles`, payload);
    }

    updateDeliveryProfile(profileId, payload) {
        return this.put(
            `${this.baseUrl}/delivery-profiles/${profileId}`,
            payload
        );
    }

    deleteDeliveryProfile(profileId) {
        return this.del(`${this.baseUrl}/delivery-profiles/${profileId}`);
    }

    syncReports(payload = {}) {
        return this.post(`${this.baseUrl}/delivery/sync-reports`, payload);
    }
}
